import {
  HeroSection,
  VisionSection,
  BOTModelSection,
  WhoWeAreSection,
  ClientsSection,
  PartnersSection,
  GlobalPresenceSection,
  ScrollReveal,
} from "../components";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ScrollReveal><VisionSection /></ScrollReveal>
      <ScrollReveal><BOTModelSection /></ScrollReveal>
      <ScrollReveal><WhoWeAreSection /></ScrollReveal>
      <ScrollReveal><ClientsSection /></ScrollReveal>
      <ScrollReveal><PartnersSection /></ScrollReveal>
      <ScrollReveal><GlobalPresenceSection /></ScrollReveal>
    </main>
  );
}
